import React, { memo, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { isEqual } from 'lodash';
import SearchInput from '../../Search/SearchInput';
import { useFilters } from '../../../providers/Filters/useFilters';

const FilterSearch = ({ filterMethod, searchTypes, clearStatus }) => {
  const [search, setSearch] = useState('');
  const [searchType, setSearchType] = useState('');

  const { filters, onChangeQuery } = useFilters();
  const filter = filters[filterMethod];

  const searchTypesOptions = useMemo(() => {
    if (!searchTypes) {
      return [];
    }
    return searchTypes.map((item) => ({
      id: item.id,
      name: item.title,
      value: item.id,
    }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTypes])

  const onSubmitSearch = (e) => {
    e.preventDefault();

    const isValidSearchType = searchType !== '' && searchType !== null && searchType !== undefined;

    const query = search;
    const search_type = isValidSearchType ? searchType : searchTypes[0].id;
    const defaultFilterType = filter.search_type === undefined ? searchTypes[0].id : filter.search_type;

    if (!isEqual(query, filter.query) || (!isEqual(defaultFilterType, search_type) && query)) {
      onChangeQuery({
        query: query || null,
        search_type: !query ? null : search_type,
        status: clearStatus ? null : (filter.status ? filter.status : null),
      })
    }
  }

  useEffect(() => {
    setSearch(filter.query);
    setSearchType(filter.search_type ? filter.search_type : searchType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter.query, filter.search_type]);

  return (
    <SearchInput
      showButton
      style={{ width: '100%' }}
      onSubmit={onSubmitSearch}
      placeholder="Search"
      onChange={(e) => setSearch(e.target.value)}
      options={searchTypesOptions}
      onChangeOption={(e) => setSearchType(e.target.value)}
      optionSelected={searchType}
      value={search}
    />
  )
}

FilterSearch.defaultProps = {
  searchTypes: [],
  filterMethod: 'query',
  clearStatus: false,
}

FilterSearch.propTypes = {
  searchTypes: PropTypes.array,
  filterMethod: PropTypes.string,
  /**
   * Убираем status при поиске
   * TASK https://app.clickup.com/t/24329429/FR-405
   */
  clearStatus: PropTypes.bool,
};

export default memo(FilterSearch);
